module.exports = __webpack_public_path__ + "static/contact-photo-d8dcc9624537a5961d9bc720244bf65e.jpg";